export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_84fad4b1-9c6e-47ec-b479-a26440d8bc93/artifacts/r64xfjak_PNG%20Logo.png";

export const COLLEGE = {
  shortName: "CCT Admissions",
  legalName: "Cambridge College of Technology Inc.",
  tagline: "CAMBRIDGE COLLEGE OF TECHNOLOGY",
  mainSite: "https://cambridgecollegebc.com",
  email: "info@cambridgecollegebc.com",
  phone: "+1 (604) 337-5300",
  campuses: ["Surrey, BC", "Vancouver, BC"],
  hours: "Mon – Fri, 9:00 – 17:00 PT",
};

export const PHONE_CODES = [
  { code: "+1", region: "US/CA" },
  { code: "+44", region: "UK" },
  { code: "+91", region: "IN" },
  { code: "+86", region: "CN" },
  { code: "+234", region: "NG" },
  { code: "+63", region: "PH" },
  { code: "+92", region: "PK" },
  { code: "+880", region: "BD" },
  { code: "+977", region: "NP" },
  { code: "+94", region: "LK" },
  { code: "+971", region: "AE" },
  { code: "+966", region: "SA" },
  { code: "+82", region: "KR" },
  { code: "+81", region: "JP" },
  { code: "+49", region: "DE" },
  { code: "+33", region: "FR" },
  { code: "+61", region: "AU" },
  { code: "+55", region: "BR" },
  { code: "+52", region: "MX" },
  { code: "+27", region: "ZA" },
  { code: "+254", region: "KE" },
  { code: "+233", region: "GH" },
  { code: "+20", region: "EG" },
  { code: "+60", region: "MY" },
  { code: "+65", region: "SG" },
  { code: "+353", region: "IE" },
  { code: "+64", region: "NZ" },
];

export const STATUS_IN_CANADA = [
  "Study Permit",
  "Work Permit",
  "Visitor",
  "Permanent Resident",
  "Canadian Citizen",
  "Refugee / Protected Person",
  "Other",
];

export const TITLES = ["Mr.", "Mrs.", "Ms.", "Mx.", "Dr.", "Other"];

export const PROVINCES = [
  "BC", "AB", "SK", "MB", "ON", "QC", "NS", "NB", "PE", "NL", "YT", "NT", "NU",
];

export const GENDERS = ["Male", "Female", "Non-binary", "Prefer not to say"];

export const STATUS_IN_COUNTRY = [
  "Canadian Citizen",
  "Permanent Resident",
  "Refugee / Protected Person",
  "Other",
];

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const PROGRAMS = [
  { name: "Accounting & Payroll", type: "Diploma" },
  { name: "Digital Marketing Management", type: "Diploma" },
  { name: "Human Resource Administration", type: "Diploma" },
  { name: "International Business", type: "Diploma" },
  { name: "Marketing Administrator", type: "Diploma" },
  { name: "Office Administrator", type: "Diploma" },
  { name: "Addiction Community Support Worker", type: "Diploma" },
  { name: "Health Care Assistant", type: "Diploma" },
  { name: "Medical Office Assistant", type: "Diploma" },
  { name: "Social Services Support", type: "Diploma" },
  { name: "Hospitality Management", type: "Diploma" },
  { name: "Network Support Administrator", type: "Diploma" },
  { name: "Network Support Technician", type: "Diploma" },
  { name: "Child Growth & Development I", type: "Certificate" },
  { name: "Child Growth & Development II", type: "Certificate" },
  { name: "Child Guidance", type: "Certificate" },
  { name: "Child Health, Safety & Nutrition", type: "Certificate" },
  { name: "Interpersonal Communication", type: "Certificate" },
  { name: "Accounting & Payroll Administration", type: "Certificate" },
  { name: "Bank Teller", type: "Certificate" },
  { name: "Corporate Sales Management Strategies", type: "Certificate" },
  { name: "English Skills For College", type: "Certificate" },
  { name: "Office Administrator", type: "Certificate" },
  { name: "ECEA Courses", type: "Certificate" },
];

export const CAMPUSES = ["Surrey", "Vancouver"];

export const AID_PROGRAMS = [
  { code: "CAD", label: "Computerized Accounting Diploma" },
  { code: "MOA", label: "Medical Office Assistant Diploma" },
];

export const AID_ACTIONS = [
  "Pending",
  "ISSUE LOA",
  "ISSUE CLOA",
  "LOA ISSUED",
  "CLOA ISSUED",
  "APPENDIX 3",
  "COE SENT",
];

export const AID_COE_STATUS = [
  { value: "not_done", label: "Not done" },
  { value: "done", label: "Done" },
];
export const AID_SEC_FORM = [
  { value: "", label: "— Select —" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];
export const AID_YES_NO = [
  { value: "", label: "— Select —" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const YEARS_EXPERIENCE = [
  "Less than 1 year",
  "1 – 2 years",
  "3 – 5 years",
  "6 – 10 years",
  "10+ years",
];

export const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Argentina","Armenia","Australia",
  "Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium",
  "Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei",
  "Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Chad","Chile","China",
  "Colombia","Congo","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark",
  "Dominican Republic","Ecuador","Egypt","El Salvador","Estonia","Ethiopia","Fiji","Finland",
  "France","Georgia","Germany","Ghana","Greece","Guatemala","Guyana","Haiti","Honduras",
  "Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica",
  "Japan","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon",
  "Liberia","Libya","Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives",
  "Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Mongolia","Montenegro",
  "Morocco","Mozambique","Myanmar","Namibia","Nepal","Netherlands","New Zealand","Nicaragua",
  "Niger","Nigeria","North Macedonia","Norway","Oman","Pakistan","Palestine","Panama",
  "Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania",
  "Russia","Rwanda","Saudi Arabia","Senegal","Serbia","Singapore","Slovakia","Slovenia",
  "Somalia","South Africa","South Korea","Spain","Sri Lanka","Sudan","Sweden","Switzerland",
  "Syria","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Trinidad and Tobago","Tunisia",
  "Turkey","Turkmenistan","Uganda","Ukraine","United Arab Emirates","United Kingdom",
  "United States","Uruguay","Uzbekistan","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"
];
